'use strict';
module.exports = require('./globals.json');



//////////////////
// WEBPACK FOOTER
// ./~/globals/index.js
// module id = 2716
// module chunks = 168707334958949